import React from 'react'
import './HowWorksContainer.scss';

export const HowWorksContainer = ({toggleHowWorks}) => {
  return (
    <div className='how-works-background'>
        <div className='how-works-container'>
            <h3>¿Cómo funciona?</h3>
            <div className='how-works-hr'></div>
            <div className='how-works-flex'>
                <div className='how-works-s1'>
                    <ul className='how-works-ul'>
                        <li>Cada materia puede estar en 3 estados: 
                            <ul className='how-works-ul2'>
                                <li>Sin regularizar</li>
                                <li>Regularizada</li>
                                <li>Aprobada</li>
                            </ul>
                        </li>
                        <li>Para cambiar el estado de una materia simplemente hay que hacer “Click” sobre ella.</li>
                        <li>Al hacer “Click” sobre una materia sin regularizar pasará a estar regularizada</li>
                        <li>Al hacer “Click” sobre una materia regularizada pasará a estar aprobada</li>
                        <li>Al hacer “Click” sobre una materia aprobada pasará a estar sin regularizar</li>
                    </ul>
                </div>
                <div className='btns-container'>
                    <p className='btns-label'>Asi se ve una materia sin regularizar:</p>
                    <button className='btn-not-regularized'>Física I</button>
                    <p className='btns-label'>Asi se ve una materia regularizada:</p>
                    <button className='btn-regularized'>Análisis Matemático I</button>
                    <p className='btns-label'>Asi se ve una materia aprobada:</p>
                    <button className='btn-approved'>Algebra y Geometría Analítica</button>
                    <p className='btns-label'>Asi se ve una materia que no podes cursar todavía:</p>
                    <button className='btn-locked'>Análisis Matemático II</button>
                </div>
            </div>
            <button className='btn-confirm' onClick={toggleHowWorks}>Entendido</button>
        </div>
    </div>
  )
}
